/*
 * This is a very simple navigation tree for testing purpose.
 * It groups URLs by features.
*/

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../authentification/redux/actions';
import { Menu, Icon } from 'antd';
import { isAccessTo } from '../../common/Dispatcher'

export class MenuApp extends PureComponent {
  static propTypes = {
    routes: PropTypes.array.isRequired,
  };

selectIcon (item){
  switch(item){
    case 'Evénements':
      return {
        icon : 'flag',
        name : 'Evénements',
       }
      break;
    
      case 'Evénements à la une':
      return {
       icon : 'star',
       name : 'Evénements à la une',
      }
      break;

      case 'Categories':
      return {
        icon : 'bars',
        name : 'Catégories',
       }
      break;

      case 'Users':
      return {
        icon : 'user',
        name : 'Utilisateurs',
       }
      break;

      case 'Settings':
      return {
        icon : 'setting',
        name : 'Paramètres',
       }
      break;

    default:
      return 'pie-chart'
  }
}

  renderLinks(items, basePath, accessParent) {
    return items.reduce((prev, item) => {
          if (item.autoIndexRoute) return prev;
          let path;
          if (/^\//.test(item.path)) {
            path = item.path;
          } else if (basePath === '/') {
            path = `/${item.path}`;
          } else {
            path = `${basePath}/${item.path}`;
          }
          if(item.visible && isAccessTo(this.props.is, item.access || accessParent))
            prev.push(<Menu.Item key={path}><Link to={path}><Icon type={this.selectIcon(item.name).icon} /><span>{this.selectIcon(item.name).name || item.path}</span></Link></Menu.Item>);

          if ( item.childRoutes 
              && item.childRoutes.length
              && item.access
              && isAccessTo(this.props.is, item.access)
              && item.childRoutes.filter((i) => i.visible).length > 0
            ) {
            prev.push(
                this.renderLinks(item.childRoutes, path, item.access)
            );
          }

          return prev;
        }, [])
    
  }

  render() {
    return (
      <Menu
        //defaultSelectedKeys={['1']}
        //defaultOpenKeys={['sub1']}
        theme="dark"
        mode="inline"
      >
        {this.renderLinks(this.props.routes[0].childRoutes, '')}

        { !this.props.is.auth ? '' : 
          <Menu.Item key="signout" style={{marginTop: "20px"}}><Link to={'/auth/signout'}><Icon type={"logout"} style={{color: "red"}}/><span>Déconnexion</span></Link></Menu.Item>
        }
      </Menu>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    is: {
      admin: state.authentification.isAdmin,
      auth: state.authentification.isAuth
    }
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuApp);



// WEBPACK FOOTER //
// ./src/features/common/MenuApp.js